import i18n from 'i18next';
import { useModals } from 'core/notifications';

export default ({ body, title = i18n.t('confirm-action') } = {}) => {
  const { addModal } = useModals();
  const input = i18n.t('confirm-action-input');

  return async () =>
    (
      await addModal({
        actions: [
          { action: 'cancel', text: i18n.t('cancel'), variant: 'ghost' },
          {
            action: 'submit',
            color: 'brand',
            getIsDisabled: ({ modalData }) => modalData.confirm !== input,
            text: i18n.t('confirm-action'),
          },
        ],
        body,
        hasCloseButton: true,
        schema: {
          confirm: {
            type: 'Text',
            label: i18n.t('confirm-action-label', { input }),
            isFullWidth: true,
            validators: [{ type: 'isRequired' }],
          },
        },
        title,
      })
    ).type === 'submit';
};
